import FileSaver from 'file-saver';

import { useAlertMessage } from 'hooks/alertMessage/useAlertMessage';
import { useApi } from 'hooks/ApiStoreContext';
import { getErrorDtoOrThrow } from 'typeGuards/typeGuards';
import { extractFileNameFromContentDisposition } from 'utils/requestUtils';

export function useDownloadPdfActionsCamunda() {
  const adminFonctionnelControllerApi = useApi().AdminFonctionnelControllerApi;

  const { alertMessage, setErrorMessage, resetAlertMessage } =
    useAlertMessage();

  const download = () => {
    void adminFonctionnelControllerApi
      .getPdfActionsCamundaUsingGET()
      .then(async (response: Response) => {
        const fileName =
          extractFileNameFromContentDisposition(response) ||
          'actions_camunda.pdf';
        FileSaver.saveAs(await response.blob(), fileName);
        resetAlertMessage();
      })
      .catch(async (error: Response) => {
        const errorDto = getErrorDtoOrThrow(await error.json());
        setErrorMessage(`Erreur : ${errorDto.message}`);
      });
  };

  return {
    download,
    alertMessage,
  };
}
